import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\cin-project\\Orange_Tiger_Nextjs\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\cin-project\\Orange_Tiger_Nextjs\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\cin-project\\Orange_Tiger_Nextjs\\src\\components\\ContactForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\cin-project\\Orange_Tiger_Nextjs\\src\\components\\Header.js");
;
import(/* webpackMode: "eager" */ "C:\\cin-project\\Orange_Tiger_Nextjs\\src\\styles\\styleblog.css");
